import React from 'react';
import { Dialog, DialogTitle, IconButton, DialogContent } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { InactiveFoliosInfo } from './Info';

interface Props {
    isDialogOpen: boolean;
    handleCloseDialog: () => void;
}

const InactiveFoliosDialog: React.FC<Props> = ({ isDialogOpen, handleCloseDialog }) => (
    <Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth="md">
        <DialogTitle style={{ paddingBottom: 0 }}>
            How to Locate Your Inactive Folios
            <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                style={{ position: 'absolute', right: 8, top: 8 }}
            >
                <Close />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <InactiveFoliosInfo />
        </DialogContent>
    </Dialog>
);

export default InactiveFoliosDialog;
